module.exports = __webpack_public_path__ + "static/media/conferencia_icon.f9b9cf14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/TransferCall/conferencia_icon.svg
// module id = 1842
// module chunks = 0